// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tree-list"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21C7.65686 21 9 19.6569 9 18C9 16.3431 7.65686 15 6 15Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M6 3C4.34315 3 3 4.34314 3 6C3 7.65685 4.34315 9 6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65686 3 6 3Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6 15V9M6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21C7.65686 21 9 19.6569 9 18C9 16.3431 7.65685 15 6 15ZM6 9C4.34315 9 3 7.65685 3 6C3 4.34314 4.34315 3 6 3C7.65686 3 9 4.34315 9 6C9 7.65685 7.65685 9 6 9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21 12L13 12M18 5L13 5M18 19H13","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TreeListIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tree-list',
    ref,
    icon: element,
  },
));

TreeListIcon.displayName = 'TreeListIcon';

export default TreeListIcon;
